import { render, staticRenderFns } from "./PrivateUsers.vue?vue&type=template&id=56c6bac6&scoped=true&"
import script from "./PrivateUsers.vue?vue&type=script&lang=js&"
export * from "./PrivateUsers.vue?vue&type=script&lang=js&"
import style0 from "./PrivateUsers.vue?vue&type=style&index=0&id=56c6bac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6bac6",
  null
  
)

export default component.exports